import React from 'react';
import TreeInfoTable from "./TreeCartTabs/TreeInfoTable";
import TreeCartTable from "./TreeCartTabs/TreeCartTable";
import {ShoppingCartIcon} from "@phosphor-icons/react";
import PopoutWindow from "../../PopoutWindow";

const TreeCart: React.FC = () => {


    const panes = [
        {
            tab: 'Tree Table',
            key: '1',
            content: <TreeInfoTable/>,
        },
        {
            tab: 'Tree Cart',
            key: '2',
            content: <TreeCartTable/>,
        },
    ];


    return (
        <>
            <PopoutWindow
                iconForButton={<ShoppingCartIcon size={28}/>}
                isOpenByDefault={false}
                panes={panes}
                tooltip={'Show Tree Cart Table'}
            />
        </>
    );
};

export default TreeCart;
